import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from '@edx/frontend-platform/i18n';
import { ActionRow, MarketingModal, ModalDialog } from '@openedx/paragon';
import CertificatePreview from '../upgrade-notification/certificate-preview';

const BaseModal = ({
  isOpen,
  close,
  courseId,
  offer,
  callToActionButton,
  children,
}) => {
  const intl = useIntl();
  const title = intl.formatMessage({
    id: 'learning.upgrade-modal.title',
    defaultMessage: 'Pursue a verified certificate',
    description: 'Upgrade modal title',
  });

  return (
    <MarketingModal
      title={title}
      isOpen={isOpen}
      onClose={close}
      isBlocking
      size="md"
      heroIsDark
      heroNode={(
        <ModalDialog.Hero
          className="justify-content-center"
          style={{
            background: 'linear-gradient(#001B1E, #0E3639)',
            borderTopLeftRadius: '6.8px',
            borderTopRightRadius: '6.8px',
          }}
        >
          <ModalDialog.Hero.Content className="m-0 text-primary-500 pt-4">
            <CertificatePreview {...{ courseId, bgColor: 'bg-light-100' }} />
          </ModalDialog.Hero.Content>
        </ModalDialog.Hero>
      )}
      footerNode={(
        <ActionRow isStacked className="mb-2">
          {offer && (
            <div className="text-center">
              {intl.formatMessage(
                {
                  id: 'learning.generic.upgradeNotification.code',
                  defaultMessage: 'Use code {code} at checkout',
                  description: 'Message to user with code for discounted course price',
                },
                {
                  code: (<span className="font-weight-bold">{offer.code}</span>),
                },
              )}
            </div>
          )}
          {callToActionButton}
        </ActionRow>
      )}
    >
      <div className="mx-n4">
        {children}
      </div>
    </MarketingModal>
  );
};

BaseModal.defaultProps = {
  offer: null,
};

BaseModal.propTypes = {
  offer: PropTypes.shape({
    code: PropTypes.string,
  }),
  // eslint-disable-next-line react/no-unused-prop-types
  variationKey: PropTypes.string.isRequired,
  courseId: PropTypes.string.isRequired,
  close: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  callToActionButton: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
};

export default BaseModal;
